<template>
  <div :class="$style.page">
    <Loading :loading="loading">
      <Title title="冻结明细" mode="margin" />

      <!-- 搜索参数 -->
      <Row>
        <Item title="类型">
          <el-select v-model="type" placeholder="全部">
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item"
              :value="index - 1"
            >
            </el-option>
          </el-select>
        </Item>

        <Item title="冻结类型">
          <el-select v-model="freezeType" placeholder="全部">
            <el-option
              v-for="(item, index) in freezeTypeList"
              :key="index"
              :label="item.financialName"
              :value="item.financialType"
            >
            </el-option>
          </el-select>
        </Item>

        <Item title="交易时间">
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="选择日期"
          />
          <div :class="$style.divider"></div>
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="选择日期"
          />
        </Item>
      </Row>

      <Row>
        <Item title="关键词">
          <el-input :class="$style.keywords" v-model="keywords"></el-input>
        </Item>

        <Button type="primary" size="small" @click="submitSearch(1)">
          搜索
        </Button>
        <Button size="small" @click="resetSearch">重置</Button>
      </Row>

      <Divider />

      <!-- 搜索结果 -->
      <Title title="提现记录" :count="total" />

      <el-table
        ref="multipleTable"
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="createdTime"
          label="交易时间"
          width="80"
          align="center"
        />

        <el-table-column
          prop="freezeAmount"
          label="冻结金额"
          width="50"
          align="center"
        />

        <el-table-column label="类型" width="50" align="center">
          <template slot-scope="scope">
            {{ scope.row.tradeType === 0 ? "冻结" : "解冻" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="freezeType"
          label="冻结类型"
          width="50"
          align="center"
        />

        <el-table-column
          prop="remarks"
          label="备注"
          width="120"
          align="center"
        />
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </Loading>
  </div>
</template>

<script>
import { getFreezeDetail, getFreezeType } from "@server";
import { formatDate } from "@utils";

export default {
  name: "Freeze",
  data() {
    return {
      typeList: ["全部", "冻结", "解冻"],
      type: -1, // 类型
      freezeTypeList: [],
      freezeType: "", // 冻结类型
      startTime: "", // 开始时间
      endTime: "", // 结束时间
      keywords: "", // 关键字

      loading: false,
      page: 1,
      limit: 20,
      showList: [],
      total: 0,
    };
  },
  methods: {
    async getFreezeType() {
      const res = await getFreezeType();
      if (res.code === 200) {
        this.freezeTypeList = res.data;
      }
    },

    async submitSearch(page = 1) {
      this.loading = true;
      this.page = page;
      const params = {
        page,
        limit: this.limit,
      };
      this.type && (params.operateType = this.type);
      this.freezeType && (params.freezeType = this.freezeType);
      this.startTime && (params.startTime = formatDate(this.startTime));
      this.endTime && (params.endTime = formatDate(this.endTime));
      this.keywords && (params.content = this.keywords);

      const res = await getFreezeDetail(params);
      const { code, data } = res;
      if (code === 200) {
        this.showList = data.list;
        this.total = data.total;
      }
      this.loading = false;
    },

    resetSearch() {
      this.type = -1;
      this.financial = "";
      this.startTime = "";
      this.endTime = "";
      this.keywords = "";
      this.submitSearch();
    },

    handlePageChange(page) {
      this.submitSearch(page);
    },
  },
  created() {
    this.getFreezeType();
    this.submitSearch();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  font-size: rem(16);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  .divider {
    width: 6px;
    height: 1px;
    background: #333;
    margin: 0 7px;
  }

  :global {
    .gl-row {
      padding-bottom: rem(40);
    }

    .gl-item {
      margin-right: rem(40);
    }

    ::v-deep .el-input {
      width: rem(200);
      margin-right: 0;

      .el-input__inner {
        padding: 0 10px;
      }

      &.el-date-editor {
        width: rem(180);
      }
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .keywords {
    width: rem(240);
  }
}
</style>
